export const PUBLICATION_SETTINGS_JSON_FIELDS = [
  'brandColors',
  'socialProfiles',
  'seo',
  'analytics',
  'advertising',
  'general',
  'homepage',
  'navigation',
  'newsletter',
  'integrations',
  'customCode',
  'advanced'
];

export const AD_JSON_TEXT_FIELDS = {
  AdPlacement: ['settings'],
  AdCampaign: ['targetPublications', 'targetPlacements'],
  AdCreative: ['trackingUrls'],
  AdDemandSource: ['configuration'],
  AdPublicationOverride: ['configurationOverride']
};

export function serializeJsonText(value) {
  if (value === null || value === undefined || typeof value === 'string') return value;
  return JSON.stringify(value);
}

export function parseJsonText(value) {
  let parsed = value;
  for (let attempt = 0; attempt < 2 && typeof parsed === 'string'; attempt++) {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      break;
    }
  }
  return parsed;
}

export function serializeJsonTextFields(data, fields) {
  const serialized = { ...data };
  for (const field of fields) {
    if (Object.prototype.hasOwnProperty.call(serialized, field)) {
      serialized[field] = serializeJsonText(serialized[field]);
    }
  }
  return serialized;
}

export function parseJsonTextFields(data, fields) {
  if (!data) return data;
  const parsed = { ...data };
  for (const field of fields) {
    if (Object.prototype.hasOwnProperty.call(parsed, field)) {
      parsed[field] = parseJsonText(parsed[field]);
    }
  }
  return parsed;
}

export function parsePublicationSettings(settings) {
  return parseJsonTextFields(settings, PUBLICATION_SETTINGS_JSON_FIELDS);
}

export function serializePublicationSettings(settings) {
  return serializeJsonTextFields(settings, PUBLICATION_SETTINGS_JSON_FIELDS);
}
